// Pinia setup for the Vue 3 app. The persisted-state plugin is registered here
// but persistence is opt-in per store; only the login-screen draft store opts
// in (see client/src/stores/loginDraft.js). Requirement 13.1.
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

export default pinia
